import React from 'react'

import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

const StripeCardElement = () => {
  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    <PaymentElement id='payment-element' options={paymentElementOptions} />
  )
}

export default StripeCardElement
